import React from 'react';
import { Link } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Toolbar,
  Typography,
  Divider
} from '@mui/material';
import { FaTools } from "react-icons/fa"; // toolbox icon
import DashboardIcon from '@mui/icons-material/Dashboard';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ArticleIcon from '@mui/icons-material/Article';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

const drawerWidth = 220;
const miniWidth = 60; // collapsed width

const DashboardSidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <Drawer
      variant="permanent"
      open={isOpen}
      sx={{
        width: isOpen ? drawerWidth : miniWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: isOpen ? drawerWidth : miniWidth,
          transition: 'width 0.3s',
          boxSizing: 'border-box',
          backgroundColor: '#1b1f24',
          color: '#fff',
          overflowX: 'hidden',
        }
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: isOpen ? 'space-between' : 'center',
          px: 1
        }}
      >
        {isOpen && <Typography variant="h6">Menu</Typography>}
        <IconButton onClick={toggleSidebar} sx={{ color: '#fff' }}>
          {isOpen ? <MenuOpenIcon /> : <MenuIcon />}
        </IconButton>
      </Toolbar>

      <Divider sx={{ backgroundColor: '#444' }} />

      <List>
        {[
          { text: 'Dashboard', icon: <DashboardIcon />, link: '/dashboard' },
          { text: 'News', icon: <NewspaperIcon />, link: '/dashboard/news' },
          { text: 'Schedule', icon: <ScheduleIcon />, link: '/dashboard/schedule' },
          { text: 'Blogs', icon: <ArticleIcon />, link: '/dashboard/blogs' },
           { text: 'Bookings', icon: <EventAvailableIcon />, link: '/dashboard/bookings' },
           { text: 'Services', icon: <FaTools />, link: '/dashboard/services' },

          { text: 'Contact', icon: <ContactMailIcon />, link: '/dashboard/contact' },
        ].map((item) => (
          <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              component={Link}
              to={item.link}
              sx={{
                minHeight: 48,
                justifyContent: isOpen ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isOpen ? 3 : 'auto',
                  justifyContent: 'center',
                  color: '#fff'
                }}
              >
                {item.icon}
              </ListItemIcon>
              {isOpen && <ListItemText primary={item.text} />}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default DashboardSidebar;
